import axios from "axios";

const instance = axios.create({
  // baseURL: process.env.NEXT_PUBLIC_BACKEND_URL_PROD,
  baseURL: "/", // process.env.NEXT_PUBLIC_BACKEND_URL_PROD,
  withCredentials: true, // Adding this line to enable sending cookies
});

export default instance;  
